// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"799":"4c6b281f","816":"ece2fb8b","867":"e91b97d6"}[chunkId] + ".js";
};